/**
 * Util
 * @description General utilities
 */

/**
 * Debug - console.log wrapper
 *
 * @param mixed obj
 */
var debug = function () {

	if ( typeof console !== 'object' || ! console.log ) {
		return;
	}

	return Function.prototype.bind.call( console.log, console );

}();

/**
 * Module Exports
 */
module.exports = {
	debug: debug
};